export const PORTFOLIO_CATEGORIES = [
  "Restaurants",
  "Hotels",
  "Cafes",
  "Cloud Kitchens",
  "Bars & Lounges",
  "Bakery & Sweets",
  "Quick Service Restaurants",
  "Fine Dining",
];
